import { render, staticRenderFns } from "./SinglePaymentMethodCD.vue?vue&type=template&id=0f4744d8&scoped=true&"
import script from "./SinglePaymentMethodCD.vue?vue&type=script&lang=js&"
export * from "./SinglePaymentMethodCD.vue?vue&type=script&lang=js&"
import style0 from "./SinglePaymentMethodCD.vue?vue&type=style&index=0&id=0f4744d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4744d8",
  null
  
)

export default component.exports